import React, { useState, useEffect, useRef } from "react";
import { IoIosArrowDown } from "react-icons/io";
import Search from "../search/Search";

const people = [
  { id: 1, name: "Adam Smith", avatar: "https://via.placeholder.com/40" },
  { id: 2, name: "Brandon James", avatar: "https://via.placeholder.com/40" },
  { id: 3, name: "Janae Yancy", avatar: "https://via.placeholder.com/40" },
  // Add more people as needed...
];

const UserSearch = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null); // New state for selected user
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleUserSelect = (user) => {
    setSelectedUser(user); // Set selected user
    setIsOpen(false); // Close dropdown
  };

  const filteredPeople = people.filter((person) =>
    person.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Close dropdown when clicking outside the component
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div ref={dropdownRef} className="custom-selector user_selector">
      <button onClick={toggleDropdown} className="btn">
        {selectedUser ? selectedUser.name : "Select..."} 
        <IoIosArrowDown />
      </button>

      {isOpen && (
        <div className="options_area">
          <Search value={searchTerm} onChange={handleSearch} />

          <ul className="options-list">
            {filteredPeople.map((person) => (
              <li
                key={person.id}
                className="user"
                onClick={() => handleUserSelect(person)} 
              >
                <img
                  src={person.avatar}
                  alt={person.name}
                  className="user_img"
                />
                {person.name}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserSearch;
